import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { DEFAULT_COLORS } from './themingHelpers';
import VARIABLE_DEFINITIONS from './themeVariableDefinitions';
function getThemeCss(theme, scope = ':root', furtherVars = '') {
    const variableDefinitions = Object.entries(VARIABLE_DEFINITIONS).map(([variableName, variableDefinition]) => {
        if (typeof variableDefinition !== 'function') {
            return `--${variableName}: ${variableDefinition};`;
        }
        return `--${variableName}: ${variableDefinition(theme)};`;
    });
    return [`${scope} {`, ...variableDefinitions, furtherVars, `}`].filter(Boolean).join('\n');
}
const FALLBACK_THEME = {
    brandPrimaryColor: '#3F1DCB',
    defaultTextColor: DEFAULT_COLORS['grey-1'],
    whiteColor: '#ffffff',
};
export const getKallidusThemeCss = (theme, scope, furtherVars) => {
    try {
        return getThemeCss(theme, scope, furtherVars);
    }
    catch (error) {
        // each UI may not validate hex colors entered by the user, so could be invalid.
        // So we fallback to a known good set of variables if so.
        console.error(error);
        return getThemeCss(FALLBACK_THEME, scope, furtherVars);
    }
};
const KallidusThemeVariables = (_a) => {
    var { brandPrimaryColor, defaultTextColor = FALLBACK_THEME.defaultTextColor, whiteColor = FALLBACK_THEME.whiteColor, scope = ':root' } = _a, otherProps = __rest(_a, ["brandPrimaryColor", "defaultTextColor", "whiteColor", "scope"]);
    const themeCss = useMemo(() => {
        const brandColors = { brandPrimaryColor, defaultTextColor, whiteColor };
        return getKallidusThemeCss(brandColors, scope);
    }, [brandPrimaryColor, defaultTextColor, whiteColor, scope]);
    return React.createElement("style", Object.assign({}, otherProps), themeCss);
};
export default KallidusThemeVariables;
//# sourceMappingURL=KallidusThemeVariables.js.map